// TODO: Update namespacing
Postlogin.Cluster = (function () {
    const me = {};

    me.page_load_id = Math.random().toString(36).substr(2, 10);

    me.init = function () {
        $('.careers.grid').on('click', '.grid-item', function () {
            $(this).addClass('selected');
            $('.grid-item').not($(this)).addClass('blur');
        });
        $('.career-clusters.grid').on('click', '.grid-item', function () {
            $(this).addClass('selected');
            $('.grid-item').not($(this)).addClass('blur');
        });

        const interest = $('#stars').attr('data-rating');

        $('.starrr').starrr({
            max: 10,
            rating: interest,
            emptyClass: 'star empty-star fa fa-star',
            fullClass: 'star full-star fa fa-star',
            change(e, value) {
                // only save value if we have a value to save.
                // for some reason, clicking on the recently saved star causes this to be 'undefined'
                if (typeof value !== 'undefined' && value > 0 && value <= 10) {
                    me.saveClusterInterest(value);

                    $('.starrr').addClass('animated tada');
                    setTimeout(() => {
                        $('.starrr').removeClass('animated tada');
                    }, 1000);
                } else {
                    me.clearClusterInterest();

                    $('.starrr').addClass('animated shake');
                    setTimeout(() => {
                        $('.starrr').removeClass('animated shake');
                    }, 1000);
                }
            },
        });

        $('.starrr').each(function () {
            $(this).find('a').each(function (i) {
                $(this).attr('aria-label', 'Rate ' + (i + 1) + ' of 10');
            });
        });

        Postlogin.CareerCentralVideo.init({
            videoType: 'Cluster Overview',
            pageLoadId: me.page_load_id,
            onPercentWatched: me.savePercentWatched,
        });
    };

    me.savePercentWatched = function (videoData) {
        $.post(`${window.location.href.split('#')[0].replace(/\/?$/, '/')}savePercentWatched/`, videoData, () => {
            //
        });
    };

    me.saveClusterInterest = function (value) {
        $.post(`${window.location.href.split('#')[0].replace(/\/?$/, '/')}saveClusterInterest/${value}/`, () => {
            //
        });
    };

    me.clearClusterInterest = function () {
        $.post(`${window.location.href.split('#')[0].replace(/\/?$/, '/')}clearClusterInterest/`, () => {
            //
        });
    };

    me.sizeStars = function () {
        $('.cluster #stars > a').css('font-size', '12px');
        const width = $('.cluster #stars').width();
        let starWidth = $('.cluster #stars > a').width();

        let originalFontSize = 12;
        originalFontSize = $('.cluster #stars > a').css('font-size');
        if (typeof originalFontSize !== 'undefined' && originalFontSize !== '') {
            originalFontSize = originalFontSize.replace(/[^-\d.]/g, '');
        }
        let newFontSize = originalFontSize;

        while (starWidth * 10 < width) {
            newFontSize++;
            $('.cluster #stars > a').css('font-size', `${newFontSize}px`);
            starWidth = $('#stars > a').width();
        }
        newFontSize--;
        $('.cluster #stars > a').css('font-size', `${newFontSize}px`);
    };

    return {
        init: me.init,
    };
}());
